/** Единые контакты витрины (СНГ / Telegram-first). */
export const SITE_TELEGRAM_URL = "https://t.me/devops_it24";
export const SITE_TELEGRAM_HANDLE = "@devops_it24";
export const SITE_EMAIL = "admin@it-24.pro";
export const SITE_PHONE_E164 = "+380631442424";
export const SITE_PHONE_DISPLAY = "+380 (63) 144-24-24";
export const SITE_NEXOPS_URL = "https://nexops.eu/";
